// Staff responses carry sell rates (cost x multiplier) instead of costs. Mapping them onto the internal cost
// fields with multiplier 1 lets the shared pricing code show suggested/final prices without any real cost data.
export const isStaff = (user) => user?.role === "staff";

export const staffItemIn = (it) => ({
  ...it, cost_per_sqft: it.sell_per_sqft ?? 0, glass_cost_per_sqft: it.glass_sell_per_sqft ?? 0,
  arch_cost_per_sqft: it.arch_sell_per_sqft ?? 0, grid_cost_per_sqft: it.grid_sell_per_sqft ?? 0, item_cost: it.item_sell ?? 0,
});

export const staffTypeIn = (t) => ({ ...t, cost_per_sqft: t.sell_per_sqft ?? 0, item_cost: t.item_sell ?? null });

export const staffCompanyIn = (c) => ({
  ...c,
  glass_options: Object.fromEntries(Object.entries(c.glass_options || {}).map(([g, opts]) => [g, opts.map((o) => ({ name: o.name, cost: o.sell }))])),
  arch_surcharge: c.arch_sell ?? 0,
  grid_costs: c.grid_sells || {},
});

const COST_KEYS = ["cost_per_sqft", "glass_cost_per_sqft", "arch_cost_per_sqft", "grid_cost_per_sqft", "item_cost"];

export const scaleCompany = (c, k) => ({
  ...c,
  glass_options: Object.fromEntries(Object.entries(c.glass_options || {}).map(([g, opts]) => [g, opts.map((o) => ({ ...o, sell: (o.sell ?? 0) * k }))])),
  arch_sell: (c.arch_sell ?? 0) * k,
  grid_sells: Object.fromEntries(Object.entries(c.grid_sells || {}).map(([g, v]) => [g, (v ?? 0) * k])),
});
export const stripCosts = (it) => Object.fromEntries(Object.entries(it).filter(([k]) => !COST_KEYS.includes(k)));
